import React from 'react';

const ConnectUs = () => {
  return (
    <section className="connect-us-section-area">
      <div className="flex items-center justify-center py-20 bg-blue-50">
        <div className="relative w-full max-w-md p-8">
          {/* Text Content */}
          <h2 className="mb-6 text-xl font-bold text-center text-gray-800">
            Contact Us
          </h2>

          {/* Email Input */}
          <div className="flex flex-col items-center mb-4">
            <form className="flex flex-row w-[100%] gap-2 mb-2" action="/contact">
              <input
                type="email"
                name='email'
                required
                placeholder="Enter your email"
                className="w-full px-4 py-2 text-gray-700 border border-blue-400 border-solid rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
              <button className="px-2 py-1 text-white bg-blue-500 rounded-lg shadow hover:bg-blue-600 w-[7rem]">
                Submit
              </button>
            </form>
            <div className="text-sm text-gray-500">OR</div>
          </div>

          {/* Button */}
          <div className="text-center">
            <a
              href="/contact?phone=true"
              style={{ margin: '0 auto' }}
              className="flex items-center justify-center gap-2 px-6 py-2 text-white bg-blue-500 rounded-lg shadow hover:bg-blue-600"
            >
              <span>Book a Call</span>
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884A2.5 2.5 0 013.001 3H6a2.5 2.5 0 012.42 1.872l.378 1.51a2.5 2.5 0 01-.406 2.23l-.772.771a11.044 11.044 0 004.943 4.943l.77-.772a2.5 2.5 0 012.231-.406l1.511.378A2.5 2.5 0 0117 14.999v2.999a2.5 2.5 0 01-2.884 2.998A17.957 17.957 0 012.003 5.884z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConnectUs;
